import { createApp } from 'vue';
import App from './App.vue';
import './assets/styles.css';

// Create and mount the Vue application
createApp(App).mount('#app');